module.exports = __webpack_public_path__ + "media/images/StarTribune-dc1e4e6111fda8b741ed08058a3f8169.png";